import React, { useState } from 'react';
import PropTypes from 'prop-types';
import css from './QuestionPanel.scss'
import { IntakeElement } from '../utils/types';
import ShortTextField from './questions/ShortTextField';
import MultiSelectField from './questions/MultiSelectField';
import LongTextField from './questions/LongTextField';
import NumberField from './questions/NumberField';
import EmailField from './questions/EmailField';
import MultipleChoiceField from './questions/MultipleChoiceField';
import YesNoField from './questions/YesNoField';
import FullDateField from './questions/FullDateField';
import ScaleField from './questions/ScaleField';
import MonthYearField from './questions/MonthYearField';
import RadioSelectField from './questions/RadioSelectField';

// These are used to match the question type provided by the backend with the component
// needed to render it. Types under the Student Surveys section are only used by the new
// backend and their mapping will not impact the legacy feature, while shared items can
// impact both features, and the deprecated items should remain untouched.
const questionComponents = {
  /**
   * Student Surveys only
   */
  CHECKBOX_SELECT: MultiSelectField,
  RADIO_SELECT: RadioSelectField,
  LONG_TEXT: LongTextField,
  NUMBER: NumberField,
  SCALE: ScaleField,
  SHORT_TEXT: ShortTextField,

  /**
   * Used by both Student Surveys and legacy Intake
   */
  EMAIL: EmailField,
  FULL_DATE: FullDateField,
  MONTH_YEAR: MonthYearField,
  PHONE: ShortTextField,
  YES_NO: YesNoField,

  /**
   * Deprecated items (legacy Intake only)
   */
  DECIMAL: NumberField,
  MULTI_STRING: MultiSelectField,
  ONE_TO_FIVE: ScaleField,
  RADIO_STRING: MultipleChoiceField,
  TEXT: ShortTextField,
  TEXT_AREA: LongTextField
};

const QuestionPanel = (props) => {

  const [hasError, setHasError] = useState(false);
  const QuestionField = questionComponents[props.intakeElement.type] || null;
  if (!QuestionField) return null;

  const setValue = (value) => {
    props.setValue(props.intakeElement.questionId, value);
  }

  const renderQuestionHeaders = () => {
    return (
      <span className={css['identity-header']}>
        {props.intakeElement.required && <span className={css['required-symbol']}>*</span>}
        {props.questionNumber && <span className={css['question-number']}>{`${props.questionNumber}. `}</span>}
      </span>
    );
  }

  const renderQuestionText = () => {
    return (
      <span className={css['question-header']}>
        {props.intakeElement.text}
      </span>
    );
  }

  const renderQuestionField = () => {
    const { intakeElement, isReadOnly, questionNumber } = props;
    return (
      <div className={css['question-field']} aria-live="polite">
        <QuestionField
          value={intakeElement.value}
          questionText={intakeElement.text}
          setValue={setValue}
          isReadOnly={isReadOnly}
          options={intakeElement.options}
          hasError={hasError}
          setHasError={setHasError}
          questionNumber={questionNumber}
          type={intakeElement.type}
          id={intakeElement.id}
        />
      </div>
    )
  }
  const errorClassName = hasError ? css['has-error'] : ''
  return (
    <div className={css['question-panel']}>
      <div className={`${css["question-block"]} ${errorClassName}`}>
        {renderQuestionHeaders()}
        {renderQuestionText()}
        {renderQuestionField()}
      </div>
    </div>
  )
}

QuestionPanel.propTypes = {
  questionNumber: PropTypes.number,
  intakeElement: IntakeElement.isRequired,
  isReadOnly: PropTypes.bool,
  setValue: PropTypes.func
}

export default QuestionPanel;
